var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2891 8.48526C19.3001 8.63715 19.3001 8.78904 19.3001 8.94234C19.3001 13.6131 15.555 19 8.70689 19V18.9972C6.68394 19 4.703 18.4498 3 17.4125C3.29415 17.4461 3.58978 17.4629 3.88615 17.4636C5.56261 17.465 7.19115 16.9309 8.51005 15.9475C6.9169 15.9188 5.51985 14.9326 5.0318 13.4927C5.58989 13.5949 6.16493 13.5739 6.71269 13.4319C4.97578 13.0987 3.72617 11.6498 3.72617 9.96707C3.72617 9.95167 3.72617 9.93697 3.72617 9.92227C4.24371 10.196 4.82317 10.3478 5.4159 10.3646C3.77999 9.32661 3.27572 7.26034 4.26361 5.64484C6.15387 7.8532 8.94281 9.19572 11.9367 9.33781C11.6366 8.11009 12.0465 6.82357 13.0138 5.96052C14.5133 4.62221 16.8717 4.6908 18.2813 6.11381C19.1151 5.95772 19.9143 5.66724 20.6456 5.25567C20.3677 6.07392 19.786 6.76897 19.0089 7.21064C19.7469 7.12805 20.4679 6.94046 21.1469 6.65418C20.6471 7.36533 20.0175 7.9848 19.2891 8.48526Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2891 8.48526C19.3001 8.63715 19.3001 8.78904 19.3001 8.94234C19.3001 13.6131 15.555 19 8.70689 19V18.9972C6.68394 19 4.703 18.4498 3 17.4125C3.29415 17.4461 3.58978 17.4629 3.88615 17.4636C5.56261 17.465 7.19115 16.9309 8.51005 15.9475C6.9169 15.9188 5.51985 14.9326 5.0318 13.4927C5.58989 13.5949 6.16493 13.5739 6.71269 13.4319C4.97578 13.0987 3.72617 11.6498 3.72617 9.96707C3.72617 9.95167 3.72617 9.93697 3.72617 9.92227C4.24371 10.196 4.82317 10.3478 5.4159 10.3646C3.77999 9.32661 3.27572 7.26034 4.26361 5.64484C6.15387 7.8532 8.94281 9.19572 11.9367 9.33781C11.6366 8.11009 12.0465 6.82357 13.0138 5.96052C14.5133 4.62221 16.8717 4.6908 18.2813 6.11381C19.1151 5.95772 19.9143 5.66724 20.6456 5.25567C20.3677 6.07392 19.786 6.76897 19.0089 7.21064C19.7469 7.12805 20.4679 6.94046 21.1469 6.65418C20.6471 7.36533 20.0175 7.9848 19.2891 8.48526Z",
    fill: "url(#paint0_linear_2614_862)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2614_862",
    x1: -37,
    y1: 12,
    x2: 178.258,
    y2: -11.5556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0888849,
    stopColor: "#FD73C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287162,
    stopColor: "#FFE04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#16E912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#43AFDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#037FF3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterHover);
export default __webpack_public_path__ + "static/media/twitterHover.06378988039889c1e5f1bb2b7b37617a.svg";
export { ForwardRef as ReactComponent };